import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { VehiculosViewerComponent } from 'src/app/components/vehiculos/vehiculos-viewer/vehiculos-viewer.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatRadioModule } from '@angular/material/radio';
import { MatStepperModule } from '@angular/material/stepper';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatInputModule } from '@angular/material/input';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatTableModule } from '@angular/material/table';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatSortModule } from '@angular/material/sort';
import { MatSelectModule } from '@angular/material/select';
import { MatCardModule } from '@angular/material/card';
import { MatChipsModule } from '@angular/material/chips';
import { RutFormatPipe } from './pipes/rutFormat.pipe';
import { MatTabsModule } from '@angular/material/tabs';
import { MatBadgeModule } from '@angular/material/badge';
import { RequestAccessViewComponent } from '../components/request-access-view/request-access-view.component';
import { NgxPrintModule } from 'ngx-print';
import { AfterPrintDirective } from '../shared/directives/after-print.directive';
import { BienesRaicesViewerComponent } from '../components/bienes-raices/bienes-raices-viewer/bienes-raices-viewer.component';
import { BoletinConcursalReportViewerComponent } from '../components/boletin-concursal/boletin-concursal-report-viewer/boletin-concursal-report-viewer.component';
import { PoderJudicialReportViewerComponent } from '../components/poder-judicial/poder-judicial-report-viewer/poder-judicial-report-viewer.component';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatMenuModule } from '@angular/material/menu';
import { MatDividerModule } from '@angular/material/divider';
import { RegcheqViewerComponent } from '../components/regcheq-viewer/regcheq-viewer.component';
import { RadialOrgChartComponent } from '../components/radial-org-chart/radial-org-chart.component';
import { DeudaLeasingSbifViewerComponent } from '../components/deuda-leasing-sbif-view/deuda-leasing-sbif-viewer.component';
import { ReporteLicitacionViewComponent } from '../components/reporte-licitacion-view/reporte-licitacion-view.component';
import { ReporteTesoreriaViewComponent } from '../components/reporte-tesoreria-view/reporte-tesoreria-view.component';
import { MatSlideToggleModule, _MatSlideToggleRequiredValidatorModule } from '@angular/material/slide-toggle';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatListModule } from '@angular/material/list';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import { MoraPresuntaViewerComponent } from '../components/direccion-trabajo/mora-presunta-viewer/mora-presunta-viewer.component';
import { ReporteF301ViewerComponent } from '../components/direccion-trabajo/reporte-f301-viewer/reporte-f301-viewer.component';
import { ReporteViewerComponent } from '../components/reporte/reporte-viewer/reporte-viewer.component';
import { ChartModule, HIGHCHARTS_MODULES } from 'angular-highcharts';
import * as HighchartsSolidGauge from 'highcharts/modules/solid-gauge'
import * as HighchartsMore from 'highcharts/highcharts-more.src';
import { GoogleChartsModule } from 'angular-google-charts';
import { MatTreeModule } from '@angular/material/tree';
import { ErrorComponent } from '../components/error/error.component';
import { AvaluoFiscalViewerComponent } from '../components/contribuciones/avaluo-fiscal-viewer/avaluo-fiscal-viewer.component';
import { ContribucionesViewerComponent } from '../components/contribuciones/contribuciones-viewer/contribuciones-viewer.component';
import { AnotacionesViewerComponent } from '../components/empresa-en-un-dia/anotaciones-viewer/anotaciones-viewer.component';
import { EstatutosViewerComponent } from '../components/empresa-en-un-dia/estatutos-viewer/estatutos-viewer.component';
import { VigenciaViewerComponent } from '../components/empresa-en-un-dia/vigencia-viewer/vigencia-viewer.component';
import { TagViewerComponent } from '../components/tag-viewer/tag-viewer.component';
import { TransunionViewerComponent } from '../components/malla-societaria/transunion-viewer/transunion-viewer.component';
import { PrintTransunionTableComponent } from '../components/malla-societaria/transunion-viewer/print-transunion-table/print-transunion-table.component';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { BalanceDetalleComponent } from '../components/financiero/balance-detalle/balance-detalle.component';
import { VentasF29Component } from '../components/financiero/ventas-f29/ventas-f29.component';
import { TotalRentaComponent } from '../components/financiero/total-renta/total-renta.component';
import { GraficosFinancierosComponent } from '../components/financiero/graficos-financieros/graficos-financieros.component';
import { ErroresReporteComponent } from '../components/financiero/errores-reporte/errores-reporte.component';
import { LineBarsComponent } from '../components/charts/line-bars/line-bars.component';
import { AlertMessageComponent } from '../components/alert-message/alert-message.component';
import { SalfaInfoRentaActualComponent } from '../pages/flujo-credito-light/fichas-clientes/plantilla-salfa-fc-light/info-dialogs/salfa-info-renta-actual/salfa-info-renta-actual.component';
import { SalfaInfoRegcheqComponent } from '../pages/flujo-credito-light/fichas-clientes/plantilla-salfa-fc-light/info-dialogs/salfa-info-regcheq/salfa-info-regcheq.component';
import { SalfaInfoContinuidadLaboralComponent } from '../pages/flujo-credito-light/fichas-clientes/plantilla-salfa-fc-light/info-dialogs/salfa-info-continuidad-laboral/salfa-info-continuidad-laboral.component';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { GenericServerSideTableComponent } from '../components/generic-server-side-table/generic-server-side-table.component';
import { GenericFilterComponent } from '../components/generic-filter/generic-filter.component';
import { MultasViewerComponent } from '../components/direccion-trabajo/multas-viewer/multas-viewer.component';
import { MatSimpleTableComponent } from '../components/tables/mat-simple-table/mat-simple-table.component';
import { SimpleTableModalComponent } from '../components/simple-table-modal/simple-table-modal.component';
import { ActuacionesViewerComponent } from '../components/empresa-en-un-dia/actuaciones-viewer/actuaciones-viewer.component';

@NgModule({
  declarations: [
    VehiculosViewerComponent,
    BienesRaicesViewerComponent,
    BoletinConcursalReportViewerComponent,
    PoderJudicialReportViewerComponent,
    RegcheqViewerComponent,
    DeudaLeasingSbifViewerComponent,
    ReporteLicitacionViewComponent,
    RutFormatPipe,
    RequestAccessViewComponent,
    RadialOrgChartComponent,
    ReporteTesoreriaViewComponent,
    MoraPresuntaViewerComponent,
    ReporteF301ViewerComponent,
    ReporteViewerComponent,
    AnotacionesViewerComponent,
    VigenciaViewerComponent,
    EstatutosViewerComponent,
    TagViewerComponent,
    AvaluoFiscalViewerComponent,
    ContribucionesViewerComponent,
    TransunionViewerComponent,
    MultasViewerComponent,
    PrintTransunionTableComponent,
    SalfaInfoRentaActualComponent,
    SalfaInfoRegcheqComponent,
    SalfaInfoContinuidadLaboralComponent,
    ErrorComponent,
    AfterPrintDirective,
    BalanceDetalleComponent,
    VentasF29Component,
    TotalRentaComponent,
    GraficosFinancierosComponent,
    ErroresReporteComponent,
    LineBarsComponent,
    AlertMessageComponent,
    GenericServerSideTableComponent,
    GenericFilterComponent,
    MatSimpleTableComponent,
    SimpleTableModalComponent,
    ActuacionesViewerComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatRadioModule,
    MatStepperModule,
    MatDialogModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatInputModule,
    MatPaginatorModule,
    MatTableModule,
    MatFormFieldModule,
    MatExpansionModule,
    MatSortModule,
    MatSelectModule,
    MatIconModule,
    MatCardModule,
    MatChipsModule,
    MatTabsModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatSidenavModule,
    MatMenuModule,
    MatDividerModule,
    MatAutocompleteModule,
    MatSlideToggleModule, 
    _MatSlideToggleRequiredValidatorModule,
    MatListModule,
    MatTooltipModule,
    MatSnackBarModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatGridListModule,
    NgxPrintModule,
    ChartModule,
    GoogleChartsModule,
    MatTreeModule,
    MatCheckboxModule,
    MatBadgeModule,
  ],
  exports: [
    VehiculosViewerComponent,
    BienesRaicesViewerComponent,
    BoletinConcursalReportViewerComponent,
    PoderJudicialReportViewerComponent,
    RegcheqViewerComponent,
    RadialOrgChartComponent,
    DeudaLeasingSbifViewerComponent,
    ReporteLicitacionViewComponent,
    ReporteTesoreriaViewComponent,
    MoraPresuntaViewerComponent,
    ReporteF301ViewerComponent,
    ReporteViewerComponent,
    AnotacionesViewerComponent,
    VigenciaViewerComponent,
    EstatutosViewerComponent,
    TagViewerComponent,
    AvaluoFiscalViewerComponent,
    ContribucionesViewerComponent,
    TransunionViewerComponent,
    MultasViewerComponent,
    PrintTransunionTableComponent,
    BalanceDetalleComponent,
    VentasF29Component,
    TotalRentaComponent,
    GraficosFinancierosComponent,
    ErroresReporteComponent,
    SalfaInfoRentaActualComponent,
    SalfaInfoRegcheqComponent,
    SalfaInfoContinuidadLaboralComponent,
    ErrorComponent,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatRadioModule,
    MatStepperModule,
    MatDialogModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatInputModule,
    MatPaginatorModule,
    MatTableModule,
    MatFormFieldModule,
    MatExpansionModule,
    MatSortModule,
    MatSelectModule,
    MatIconModule,
    MatCardModule,
    MatChipsModule,
    MatTabsModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatSidenavModule,
    MatMenuModule,
    MatDividerModule,
    MatSlideToggleModule, 
    _MatSlideToggleRequiredValidatorModule,
    MatGridListModule,
    MatListModule,
    MatTooltipModule,
    MatSnackBarModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatAutocompleteModule,
    RutFormatPipe,
    RequestAccessViewComponent,
    AfterPrintDirective,
    NgxPrintModule,
    ChartModule,
    GoogleChartsModule,
    MatTreeModule,
    GenericServerSideTableComponent,
    GenericFilterComponent,
    MatCheckboxModule,
    LineBarsComponent,
    AlertMessageComponent,
    MatSimpleTableComponent,
    SimpleTableModalComponent,
    ActuacionesViewerComponent,
    MatBadgeModule,
  ],
  providers: [
    {
      provide: HIGHCHARTS_MODULES,
      useFactory: () => [HighchartsMore, HighchartsSolidGauge]
    },
  ]
})
export class SharedModule { }
